import React, { useState } from 'react';
import WebApp from '@twa-dev/sdk';
import axios from 'axios';
import { API_URL } from '../config';
import { useUser } from '../context/UserContext';

export default function TermsAndConditions() {
  const { userData, APIKey, setUserData } = useUser();
  const [loading, setLoading] = useState(false);

  // Check if launched from bot via startapp param
  const startParam = WebApp.initDataUnsafe?.start_param || "";
  const isFromBot = startParam.startsWith("fromBot");
  const parts = startParam.split("_");
  
  let botUsername = "biscopemoviestorebot";
  let msgId = "";
  let originalPayload = "none";
  
  if (isFromBot) {
    if (isNaN(parts[1])) {
      // New format: fromBot_botUsername_msgId_payload
      botUsername = parts[1];
      msgId = parts[2];
      originalPayload = parts.slice(3).join("_") || "none";
    } else {
      // Old format: fromBot_msgId_payload
      msgId = parts[1];
      originalPayload = parts.slice(2).join("_") || "none";
    }
  }

  const handleAccept = async () => {
    setLoading(true);
    try {
      const userId = userData.userId || userData.user?.userId;
      if (userId) {
        await axios.post(`${API_URL}/api/user/${userId}/accept-terms`, {}, {
          params: { initData: WebApp.initData },
          headers: { "x-api-key": APIKey },
        });
        
        // The successful response confirms acceptance; avoid another fingerprint
        // calculation and network fetch before returning to the bot.
        setUserData(prev => ({ ...prev, user: { ...prev.user, acceptedTerms: true } }));
        
        // Close the Telegram Web App if launched from the bot's terms prompt
        if (isFromBot) {
          if (msgId) {
            WebApp.openTelegramLink(`https://t.me/${botUsername}?start=resume_${msgId}_${originalPayload}`);
          }
          WebApp.close();
        }
      }
    } catch (error) {
      console.error("Failed to accept terms:", error);
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col bg-[#1c1c1e] text-white overflow-hidden">
      {/* Header */}
      <div className="flex-shrink-0 pt-6 pb-4 px-6 border-b border-[#2c2c2e] bg-[#1c1c1e] z-10 shadow-md">
        <h1 className="text-2xl font-bold text-center bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
          Terms & Conditions
        </h1>
        <p className="text-center text-sm text-gray-400 mt-2">
          Please read and accept our policies to continue using the bot.
        </p>
      </div>

      {/* Scrollable Content Area */}
      <div className="flex-grow overflow-y-auto p-6 space-y-6 text-sm text-gray-300 leading-relaxed bg-[#1c1c1e]">
        
        <section>
          <h2 className="text-lg font-semibold text-white mb-2">၁။ စည်းကမ်းချက်များကို လက်ခံခြင်း</h2>
          <p>
            ဤ Bot နှင့် Mini-app ကို အသုံးပြုခြင်းဖြင့် အောက်ပါစည်းကမ်းချက်များကို သဘောတူလက်ခံရာရောက်ပါသည်။
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-2">၂။ အသုံးပြုမှု စည်းကမ်းချက်များ</h2>
          <ul className="list-none space-y-2">
            <li>၁။ အခြားချန်နယ်ပိုင်ရှင်များ ဝယ်ယူခြင်း ခွင့်မပြုပါ။</li>
            <li>၂။ Biscope Store မှ ဝယ်ယူထားသော ရုပ်ရှင်များကို ချန်နယ်ထောင်၍ ပြန်လည်ဖြန့်ဝေခြင်း (သို့မဟုတ်) ပြန်လည်ရောင်းချခြင်းများကို လုံးဝ (လုံးဝ) ခွင့်မပြုပါ။</li>
            <li>၃။ Biscope Mini App မှ Task များကို လုပ်ဆောင်ရာတွင် အမှန်တကယ် မလုပ်ဆောင်ပဲ Gem ရရုံ သက်သက် လိမ်ညာပြုလုပ်ခြင်း ခွင့်မပြုပါ။</li>
            <li>၄။ အဘန်းခံရပြီးသူများမှ အကောင့်တုများ၊ အကောင့်ပွားများဖြင့် ထပ်မံ ဝယ်ယူခြင်း ခွင့်မပြုပါ။</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-white mb-2">၃။ အကောင့်ပိတ်သိမ်းခြင်း (Account Ban)</h2>
          <p>
            စည်းကမ်းဖောက်ဖျက်ကြောင်း တွေ့ရှိပါက မည်သည့်သတိပေးချက်မှမရှိဘဲ မိမိအကောင့်ကို ချက်ချင်းပိတ်သိမ်း (Ban) မည်ဖြစ်ပြီး ဝယ်ယူထားပြီးသော ချန်နယ်များမှ အပြီးတိုင် ထုတ်ပယ်ပါမည်။ ငွေလွှဲထားပါက ငွေပြန်လည် ရရှိမည် မဟုတ်ပဲ ငွေဖြည့်ထားပါကလည်း ငွေပြန်လည် ထုတ်ယူခွင့် ရရှိမည် မဟုတ်ပါ။
          </p>
        </section>
        
        {/* Extra spacing at bottom so content isn't hidden behind the floating button */}
        <div className="h-24"></div>
      </div>

      {/* Footer with Floating Button */}
      <div className="flex-shrink-0 p-6 bg-gradient-to-t from-[#1c1c1e] via-[#1c1c1e] to-transparent absolute bottom-0 left-0 right-0 z-10">
        <button
          onClick={handleAccept}
          disabled={loading}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-4 px-6 rounded-xl shadow-lg transition-transform transform active:scale-95 disabled:opacity-50 disabled:active:scale-100 flex justify-center items-center gap-2 text-lg"
        >
          {loading ? (
            <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          ) : (
            isFromBot ? "Accept & Close" : "Accept"
          )}
        </button>
      </div>
    </div>
  );
}
